
export const userColumns = [


    {
        field: "voucherNumber",
        headerName: "Voucher Number",
        width: 380,
    },

    {
        field: "voucherDate",
        headerName: "Voucher Date",
        width: 380,
    },


    {
        field: "amount",
        headerName: "Amount",
        width: 150,
    },


    {
        field: "description",
        headerName: "Description",
        width: 380,
    },
];